import { SudoConsts } from 'client/util/Constants';
import ItemSummary, { DisplayConfig } from 'client/components/ItemTable/BodyComponents/UserGroupSummary/ItemSummary';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

export const assignedResourcesMapping = {
  systemGroups: {
    title: 'Device Groups',
    iconLocation: 'img/groups/device-groups.svg',
    fallbackLinkText: 'Assign a device group.',
    fallbackMessage: 'No device groups have been assigned.',
    listMapping: ({ name }) => name,
  },
  application: {
    title: 'Applications',
    iconLocation: 'img/groups/applications.svg',
    fallbackLinkText: 'Assign an application.',
    fallbackMessage: 'No applications have been assigned.',
    listMapping: ({ displayLabel }) => displayLabel,
  },
  radiusServers: {
    title: 'Radius',
    iconLocation: 'img/groups/radius.svg',
    fallbackLinkText: 'Assign a radius network.',
    fallbackMessage: 'No radius networks have been assigned.',
    listMapping: ({ name }) => name,
  },
  directories: {
    title: 'Directories',
    iconLocation: 'img/groups/directories.svg',
    fallbackLinkText: 'Assign a directory.',
    fallbackMessage: 'No directories have been assigned.',
    listMapping: ({ name }) => name,
  },
};

export const sudoResourcesMapping = {
  sudo: {
    title: SudoConsts.sudo,
    iconLocation: 'img/groups/admin-sudo-icon.svg',
    fallbackLinkText: '',
    fallbackMessage: '',
  },
  sudoWithoutPassword: {
    title: SudoConsts.passwordless,
    iconLocation: 'img/groups/passwordless-sudo-icon.svg',
    fallbackLinkText: '',
    fallbackMessage: '',
  },
};

export const itemSummaries = {
  assignedResourcesSummary: (params = {}) => new ItemSummary({
    areThereResources: items => !!items.length
     && items.some(assignedResource => !!assignedResource.items.length),
    fallbackLinkText: 'Learn about user groups.',
    fallbackLinkUrl: KbArticleUrls.gettingStartedGroups,
    fallbackMessage: 'There are no assigned resources.',
    items: [],
    itemType: 'resources',
    openLinkInNewTab: true,
    title: 'Assigned resources',
    ...params,
  }),

  suggestionsSummary: (params = {}) => new ItemSummary({
    fallbackLinkText: 'Create a rule to see suggested users for this user group.',
    fallbackMessage: 'A rule has not been set for this group. ',
    items: [],
    itemType: 'suggestions',
    openLinkInNewTab: false,
    title: 'Membership suggestions based on:',
    displayConfig: new DisplayConfig({
      itemsSeparators: 'AND',
      startWord: 'When',
    }),
    ...params,
  }),

  attributesSummary: (params = {}) => new ItemSummary({
    fallbackLinkText: 'Learn more.',
    fallbackLinkUrl: KbArticleUrls.groupInheritedUserAttributes,
    fallbackMessage: 'Custom attributes have not been set for this group.',
    items: [],
    itemType: 'customAttributes',
    openLinkInNewTab: true,
    title: 'Custom attributes',
    ...params,
  }),
};
